import React from "react";
import { H1 } from "../Headers";
import styled from "styled-components";
import NotificationSettings from "../notifications/NotificationSettings";

const Container = styled.div`
  margin: 3em;
`;

const ManageNotifications = () => {
  return (
    <Container>
      <H1>Manage Notifications</H1>
      <NotificationSettings />
    </Container>
  );
};

export default ManageNotifications;
